"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _visua = _interopRequireDefault(require("./components/visua"));
var _table = _interopRequireDefault(require("./components/table"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    product: _visua.default,
    tableData: _table.default
  },
  data: function data() {
    return {
      newCustomer: null
    };
  },
  mounted: function mounted() {},
  methods: {
    srectEd: function srectEd(value) {
      console.log(value);
      this.newCustomer = value;
    }
  }
};